/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DispatchAgentRequest } from '../../models/dispatch-agent-request';
import { DispatchAgentResult } from '../../models/dispatch-agent-result';

export interface ApiAgentsIdDispatchPost$Params {
  id: string;

/**
 * Space to act in. Omit to use the user's default space. Must be a space the user belongs to, otherwise the request is rejected.
 */
  'x-space-id'?: string;
      body?: DispatchAgentRequest
}

export function apiAgentsIdDispatchPost(http: HttpClient, rootUrl: string, params: ApiAgentsIdDispatchPost$Params, context?: HttpContext): Observable<StrictHttpResponse<DispatchAgentResult>> {
  const rb = new RequestBuilder(rootUrl, apiAgentsIdDispatchPost.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('x-space-id', params['x-space-id'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DispatchAgentResult>;
    })
  );
}

apiAgentsIdDispatchPost.PATH = '/api/Agents/{id}/dispatch';
